import setup from './doingCreate_application_readerSetup';

// Buttons inside the setup page use the same active form as its toolbar.
export default {
    ...setup,
    verb: 'doingMark',
    logic: args =>
        setup.logic({
            ...args,
            data: { ...args.data, record: args.data.activeRecord?.record },
            context: { ...args.context, formInstanceId: args.data.activeRecord?.formInstanceId }
        })
};
